import { gsap } from 'gsap'
import { Howl, Howler } from 'howler'
import { ref, watch } from 'vue'

import { getAssetURL } from '@/utils'

const TRACKS = {
  background: 'background',
  click: 'click',
  close: 'close',
  popup: 'popup'
} as const

const globalAudio = ref({
  enabled: false,
  volume: 0
})

export const toggleGlobalAudio = () => (globalAudio.value.enabled = !globalAudio.value.enabled)

export function useAudio (trackName: keyof typeof TRACKS) {
  const audio = new Howl({
    src: getAssetURL(`sounds/${TRACKS[trackName]}.mp3`),
    loop: trackName === 'background'
  })
  return audio
}

watch(
  () => globalAudio.value.enabled,
  (v) => {
    gsap.to(globalAudio.value, {
      volume: v ? 0.5 : 0,
      duration: 1,
      ease: 'sine.inOut',
      onUpdate: () => {
        Howler.volume(globalAudio.value.volume)
      }
    })
  },
  { immediate: true }
)
